import { FormEvent, useState } from 'react';

type useFormType = {
  validated: boolean;
  formSubmitCallback: (event: FormEvent<HTMLFormElement>) => void;
};
const useFormHtml = <FormType>(formValidCallback: (target: EventTarget & FormType) => void): useFormType => {
  const [validated, setValidated] = useState<boolean>(false);

  const formSubmitCallback = (event: FormEvent<HTMLFormElement>) => {
    setValidated(false);
    event.preventDefault();
    event.stopPropagation();
    if (event.currentTarget.checkValidity()) {
      // form is valid execute callback
      try {
        formValidCallback(event.target as EventTarget & FormType);
      } catch (_err: unknown) {
        console.log({ _err, event, target: event.target });
      }
    } else {
      // form is not valid, report feedback
      console.log({ error: 'Form is not valid' });
      event.currentTarget.reportValidity();
    }
    setValidated(true);
  };
  return { validated, formSubmitCallback };
};

export default useFormHtml;
